<div style="width: 100%; display: flex; justify-content: center; padding: 2px 0;">
    <img src="https://lutzangeles.blob.core.windows.net/app/LutzAngeles_Subscribe_v2.png" [style]="inversionFilter" style="width: 100%; max-width: 432px;position: relative;top:-32px;" />
</div>
<!--<div>-->
    <div style="text-align: center; font-weight: bold; margin-bottom: 16px;">
        Enter your cell phone number with area code
    </div>
    <div style="max-width:600px;margin:0 auto;">
        <div style="display:flex;justify-content:center;align-items:center;gap:8px;">

            <!-- iOS SPECIFIC PLATFORM ROUTE: Isolated Raw Native Element
    <div *ngIf="isIos" class="ios-input-container">
        <input type="tel"
               inputmode="tel"
               autocomplete="tel"
               name="input_ios"
               placeholder="10 digit phone"
               [(ngModel)]="phoneNumber"
               maxlength="11"
               class="ios-native-field" />
    </div>
    -->
            <mat-form-field appearance="outline"
                            class="popoutHighlight" 
                            style="flex: 0 1 360px;max-width: 140px;">
                <mat-label>Phone Number</mat-label>
                <div>
                    <input matInput
                           #phoneInput
                           type="tel"
                           inputmode="numeric"
                           autocomplete="tel"
                           name="input_masked"
                           placeholder="Enter phone number"
                           [(ngModel)]="phoneNumber"
                           mask="(000) 000-0000" />
                </div>
            </mat-form-field>
            <button mat-raised-button color="primary" (click)="subscribe()" [disabled]="!setValidPhoneNumber()" style="height:52px;line-height:52px;padding:0 16px;position:relative;top:-10px;">Subscribe</button>
        </div>
    </div>
    <div style="text-align: left; font-size: 9px; color: var(--color-secondary); max-width: 600px; margin: 0 auto; line-height: 1.5; ">
        By signing up, you agree to receive recurring automated promotional and personalized marketing text messages
        (e.g. News articles, product reminders) from Lutz Angeles at the cell number used when signing up.
        Message and Data Rates May Apply. Messages automatically dialed. Consent is not a condition of any purchase.
        Text HELP for help. Text STOP to stop.
    </div>
    <br />
    <div style="text-align: center; font-size: 11px; color: var(--color-secondary); max-width: 600px; margin: 0 auto; line-height: 1.5;">
        By signing up, you agree to the Lutz Angeles <a href="javascript:void(0)" (click)="goToTermsOfUse()" style="color:#007bff; text-decoration:underline;"> Terms-of-Use </a> and <a href="javascript:void(0)" (click)="goToPrivacyPolicy()" style="color:#007bff; text-decoration:underline;">Privacy Policy</a>.
    </div>
<!--</div>-->
